import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6.0026 9.33333L10.0026 5.33333M6.33596 5.66667H6.34262M9.66929 9H9.67596M12.6693 14V3.33333C12.6693 2.59695 12.0723 2 11.3359 2H4.66927C3.93289 2 3.33594 2.59695 3.33594 3.33333V14L5.66927 12.6667L8.0026 14L10.3359 12.6667L12.6693 14ZM6.66927 5.66667C6.66927 5.85076 6.52003 6 6.33594 6C6.15184 6 6.0026 5.85076 6.0026 5.66667C6.0026 5.48257 6.15184 5.33333 6.33594 5.33333C6.52003 5.33333 6.66927 5.48257 6.66927 5.66667ZM10.0026 9C10.0026 9.1841 9.85337 9.33333 9.66927 9.33333C9.48518 9.33333 9.33594 9.1841 9.33594 9C9.33594 8.81591 9.48518 8.66667 9.66927 8.66667C9.85337 8.66667 10.0026 8.81591 10.0026 9Z" />
  </svg>
);
